import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const TenteTamiriPage = () => {
  useEffect(() => {
    document.title = 'Tente Tamiri - İzmir Tente Tamir | Profesyonel Tamir Hizmeti';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde profesyonel tente tamiri hizmeti. Yırtık, delik, mekanizma arızası gibi tüm tente sorunlarına hızlı ve kaliteli çözümler sunuyoruz. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Körüklü Tente Tamiri', link: '/hizmetler/koruklu-tente-tamiri' },
    { title: 'Mafsallı Tente Tamiri', link: '/hizmetler/mafsalli-tente-tamiri' },
    { title: 'Branda Değişimi', link: '/hizmetler/branda-degisimi' },
    { title: 'Tente Yenileme', link: '/hizmetler/tente-yenileme' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-20 md:pt-24">
        <div className="w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/22d9e81d173b971898f5befea94e00e9.jpg"
            alt="Tente Tamiri"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6 mt-8">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Tente Tamiri</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Tente Tamiri
              </h1>
              
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                Tenteler, güneş ışığından korunma ve estetik görünüm sağlama açısından konut ve ticari alanlarda vazgeçilmez unsurlardır. Ancak zamanla hava koşulları, kullanım sıklığı ve bakım eksikliği nedeniyle çeşitli sorunlar ortaya çıkabilir. İzmir Tente Tamir olarak, her türlü tente arızasına profesyonel çözümler sunuyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tente Tamiri Nedir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Tente tamiri, mevcut tente sistemlerinde oluşan fiziksel hasarların, mekanik arızaların ve işlevsel sorunların giderilmesi işlemidir. Bu hizmet, tentenin ömrünü uzatır ve yeniden tam performansla çalışmasını sağlar. Profesyonel tente tamiri, hem maliyet tasarrufu sağlar hem de yeni tente alımına göre çok daha hızlı bir çözüm sunar.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Hangi Tente Sorunlarını Gideriyoruz?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                İzmir Tente Tamir olarak geniş bir yelpazede tente sorunlarına müdahale ediyoruz:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Branda Yırtıkları ve Delikleri:</strong> Hava koşulları veya fiziksel darbelere bağlı oluşan yırtık ve delikleri onarıyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Mekanizma Arızaları:</strong> Açılma-kapanma sistemlerindeki sorunları tespit edip düzeltiyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kol ve Mafsallarda Kırılma:</strong> Metal aksamlardaki kırılma ve bükülmeleri tamir ediyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Motor Arızaları:</strong> Motorlu tente sistemlerindeki elektriksel ve mekanik sorunları çözüyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Renk Solması ve Eskime:</strong> Branda yenileme hizmetimizle tentelerinize yeni bir görünüm kazandırıyoruz.</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tente Tamiri Süreci Nasıl İşler?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Profesyonel tente tamiri sürecimiz şu adımlardan oluşur:
              </p>
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">1. Ücretsiz Keşif ve Değerlendirme</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Uzman ekibimiz, tentenizin durumunu yerinde inceleyerek sorunları tespit eder. Hangi parçaların tamir edilmesi veya değiştirilmesi gerektiğini belirler ve size detaylı bir rapor sunar.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">2. Fiyat Teklifi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Keşif sonrasında, yapılacak işlemlere dair şeffaf ve net bir fiyat teklifi sunuyoruz. Gizli maliyet veya ek ücret bulunmaz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">3. Tamir İşlemi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Onayınızın ardından, deneyimli teknisyenlerimiz tamir işlemini hızlı ve özenli bir şekilde gerçekleştirir. Kaliteli yedek parça ve malzeme kullanımına özen gösteririz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">4. Test ve Teslim</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Tamir tamamlandıktan sonra, tentenizin tam performansla çalıştığından emin olmak için kapsamlı testler yapıyoruz. Ardından size teslim ediyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Neden İzmir Tente Tamir?</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Deneyimli Ekip:</strong> 15 yılı aşkın sektör deneyimi ile her türlü tente sorununa çözüm üretiyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kaliteli Malzeme:</strong> Orijinal ve dayanıklı yedek parçalar kullanıyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı Servis:</strong> Acil durumlarda aynı gün müdahale imkanı sunuyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uygun Fiyat:</strong> Şeffaf ve rekabetçi fiyatlarla hizmet veriyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Garanti:</strong> Tüm tamir işlemlerimiz garanti kapsamındadır.</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tente Bakım İpuçları</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Tentenizin ömrünü uzatmak ve büyük tamirlere gerek kalmadan kullanmak için düzenli bakım önemlidir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Tenteyi düzenli olarak yumuşak bir fırça ve su ile temizleyin</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Fırtınalı havalarda tenteyi kapalı tutun</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Mekanizma aksamlarını yılda bir kez yağlayın</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Küçük yırtıkları hemen tamir ettirin</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mt-8">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-sm md:text-base text-gray-700 mb-6">
                  Tente tamiriniz için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TenteTamiriPage;